/**
 * @author Jersson Morales
 * @Copyright (c) Infotrack. All rights reserved.
 */
export default {
    'sidebar.flujosEtapas': 'Stages flows',
    'flujosEtapas.agregarFlujosEtapas': 'Create Stages flows',
    'flujosEtapas.modificarFlujosEtapas': 'Edit Stages flows',
    'flujosEtapas.eliminarFlujosEtapas': 'Delete Stages flows',
    'flujosEtapas.flujoDescripcion': 'Flow Description',
    'flujosEtapas.etapaDescripcionActual': 'Current Stage',
    'flujosEtapas.etapaDescripcionSiguiente': 'Next stage',
    'flujosEtapas.empresaId': ' Company Id',
    'flujosEtapas.entrada': ' Entry',
    'flujosEtapas.estado': ' Status',
    'flujosEtapas.etapaActual': ' Current Stage',
    'flujosEtapas.etapaSiguiente': ' Next Stage',
    'flujosEtapas.flujoEtapaId': ' Flow Stage Id',
    'flujosEtapas.flujoId': 'Flow',
    'flujosEtapas.salida': ' Output',
    'flujosEtapas.flujosEtapas': 'Stages flows',
    'flujosEtapas.verFlujosEtapas': 'View Stages flows',
    'flujoEtapa.EtapasInicialCreadaEliminacion':
        'It is not possible to delete the record, you must have a record with initial stage created.',
    'flujoEtapa.EtapasInicialCreadaEdicion':
        'It is not possible to edit the record, you must have a record with initial stage created.',
    'flujoEtapa.EtapasInicialCreadaEstado':
        'It is not possible to edit the record, you must have an active record with initial stage created.',
};
